// extracted by mini-css-extract-plugin
export default {"main":"Dashboard_main__l52uY","bg":"Dashboard_bg__niFwC"};